interface EnvConfig {
  API_URL: string;
  IS_DEVELOPMENT: boolean;
}

const getEnvConfig = (): EnvConfig => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  // In development, use localhost:8888
  // In production, use api.transfersnews.org
  const apiUrl = isDevelopment 
    ? 'https://api.transfersnews.org'
    : 'https://api.transfersnews.org';

  return {
    API_URL: apiUrl,
    IS_DEVELOPMENT: isDevelopment
  };
};

export const env = getEnvConfig(); 